import { useSelector } from "react-redux";
import { getPrintSettings } from "../../../ducks/print/selectors";
import { PrintSettings } from "../../../interfaces/print";

export const usePrintSettings = (): PrintSettings => useSelector(getPrintSettings);
